export const RECEIPT_ROUTING = [
    {
        path: '/receipt',
        name: 'receipt',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Yêu cầu giao', pathName: 'receipt', icon: 'fa fa-file-code-o' },
            ]
        },
        component: () => import('./Receipt.vue'),
        redirect: { name: 'receipt-index' },
        children: [
            { 
                path: '/phieu-xuat-kho.html',
                name: 'receipt-index',
                component: () => import('./components/main-receipt/MainReceipt.vue')
            },
            {
                path: '/yeu-cau-giao-hang.html',
                name: 'payment-request-new',
                meta: {
                    breadcrumb: [
                        { name: 'Tạo mới yêu cầu giao hàng', pathName: 'yeu-cau-giao-hang', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/add-new-payment-request/AddNewPaymentRequest.vue'),
            },
            {
                path: '/phieu-xuat-kho/:id',
                name: 'receipt-detail',
                meta: {
                    breadcrumb: [
                        { name: 'Chi tiết yêu cầu giao', pathName: 'receipt-detail', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/detail-receipt/DetailReceipt.vue'),
            }
        ]
    }
];